// Общие контсанты для различных компонентов.
export const CLASS_ACTIVE = 'active';
export const CLASS_SHOW = 'show';
export const CLASS_EMPTY = '';
export const READY = 'ready';
export const LOADING = 'loading';
export const ERROR = 'error';
